import React from 'react'

import { LazyComponent, SpookySkeleton } from '@offerzen/pinata-shame'

import SkeletonToolbar from '@/core/skeletons/SkeletonToolbar'

const EditCompanyProfileLazy = props => (
  <LazyComponent componentName="editCompanyProfile" loader={() => import('./EditCompanyProfileScene')}>
    {EditCompanyProfileScene => (
      <Choose>
        <When condition={EditCompanyProfileScene}>
          <EditCompanyProfileScene {...props} />
        </When>

        <Otherwise>
          <SpookySkeleton>
            <SkeletonToolbar />
          </SpookySkeleton>
        </Otherwise>
      </Choose>
    )}
  </LazyComponent>
)

export default EditCompanyProfileLazy
